// extracted by mini-css-extract-plugin
module.exports = {"Comparison":"Comparison_back_Comparison__lKpfx"};